import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BailListComponent } from './bail-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BailService } from './bail.service';
import { ExpenseService } from '../expenses/expense.service';
import { ExpenseFormModel } from '../expenses/expenseform.model';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { BailModel } from './bail.model';
import { ExpensesRecievedConst } from '../const';

@Component({
    selector: 'convfact-bailassignexpense',
    templateUrl: './bail-dialog-assignExpense.component.html',
    styleUrls: ['./bail.component.css'],
    standalone: false
})
export class BailDialogAssignExpenseComponent implements OnInit {
  uid: string = this.data.uid;
  type: string = this.data.type;
  totalAmount: number = this.data.totalAmount;
  proveedorUid: string = this.data.proveedorUid;

  error_msg: string;
  error: boolean = false;
  dataSourceNotFiltered: ExpenseFormModel[] = [];
  dataSource: ExpenseFormModel[] = [];
  activities: ActivityModel[] = [];
  bail: BailModel;
  ready = false;

  headerTable: any[] = ExpensesRecievedConst.headerTable;


  constructor(
    public dialogRef: MatDialogRef<BailListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public bailService: BailService,
    public expenseService: ExpenseService,
    public activityService: ActivityService
  ) { }

  assign(uid: string, expenseNumber: string) {
    this.ready = true;
    this.bailService.loadData(this.uid).then(response => {
      this.bail = response;
      this.bail.invoiceUid = uid;
      this.bail.expenseNumber = expenseNumber;
      this.bailService.editData(this.uid, this.bail).then(response => {
        this.ready = false;
        this.closeDialog();
      })
    })
  }

  delete() {
    this.bailService.deleteData(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.expenseService.getAllList().then(response => {
      this.dataSourceNotFiltered = response;

      if (this.proveedorUid !== null && this.proveedorUid !== "") {
        this.dataSourceNotFiltered = this.dataSourceNotFiltered.filter(f => f.receiverUid == this.proveedorUid);
      }

      this.dataSourceNotFiltered.forEach(expense => {
        if (expense.paided == null) {
          if ((expense.total - expense.totalPaided) >= this.totalAmount) {
            this.dataSource.push(expense);
          }
        }
      })
      this.activityService.getList().then(response => {
        this.activities = response;
        this.ready = true;
      })
    })
  }

  public trackByIndex(i: number) { return i; }

}